import styled from 'styled-components';

export const Body = styled.div`
  overflow-x: hidden;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 40px;
`;

export const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  z-index: 10;
  background: rgba(255, 255, 255, 0.9);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #333;
  font-size: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
`;

export const ArrowContainer = styled.button<{ right?: string; left?: string }>`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: none;
  padding: 10px;
  margin: 0;
  ${({ right }) => (right ? 'right: 10px;' : 'left: 10px;')}
  z-index: 1;
  cursor: pointer;

  img {
    width: 30px;
    height: 30px;
  }
`;

export const TextContainer = styled.div`
  flex: 1;
  padding: 0;
  text-align: left;
`;

export const TitleText = styled.div`
  font-size: 20px;
  font-weight: bold;
  color: #333;
  margin-bottom: 5px;
  text-align: left;
`;

export const Time = styled.div`
  font-size: 14px;
  color: #999;
  text-align: left;
`;

export const All = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
  gap: 15px;
`;

export const ImageSlider = styled.div`
  position: relative;
  width: 100%;
  max-width: 480px;

  .img {
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

  .slide-container {
    width: 100%;
  }
`;

export const MapInfo = styled.div`
  margin-top: 5px;
`;

export const DetailTitle = styled.div`
  font-size: 13px;
  color: #999;
  margin-bottom: 8px;
  padding: 0 20px;
  text-align: left;
`;

export const DetailContent = styled.div`
  font-size: 15px;
  color: #333;
  margin-bottom: 15px;
  line-height: 1.5;
  padding: 0 20px;
  text-align: left;
`;

export const Map = styled.div`
  margin: 15px 0 0 0;
  padding: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  box-sizing: border-box;
`;

export const LocationData = styled.div`
  padding: 0;
`;

export const DataContainer = styled.div`
  margin-top: 30px;
`;

export const FacilitiesSection = styled.div`
  margin-top: 30px;
  padding: 0 20px;
`;

export const FacilitiesTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  text-align: left;
`;

export const FacilitiesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
`;

export const FacilityCard = styled.div`
  background: white;
  border: 1px solid #E5E5E5;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }
`;

export const FacilityImageWrapper = styled.div`
  width: 100%;
  height: 120px;
  background: #F5F5F5;
  overflow: hidden;
`;

export const FacilityImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FacilityInfo = styled.div`
  padding: 12px;
`;

export const FacilityName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FacilityLocation = styled.div`
  font-size: 12px;
  color: #999;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FacilityPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 48px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
`;

export const EmptyFacilities = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;

export const LiveTalkSection = styled.div`
  margin-top: 30px;
  padding: 0 20px;
  margin-bottom: 20px;
`;

export const LiveTalkHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
`;

export const LiveTalkTitle = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #333;
`;

export const ViewAllButton = styled.button`
  border: none;
  background: none;
  color: #1FBC70;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  padding: 0;

  &:hover {
    text-decoration: underline;
  }
`;

export const LiveTalkList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const LiveTalkItem = styled.div`
  padding: 12px 15px;
  background: #F8F9FA;
  border-radius: 12px;
  cursor: pointer;

  &:hover {
    background: #F0F1F3;
  }
`;

export const LiveTalkItemHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

export const LiveTalkProfileImage = styled.img`
  width: 28px;
  height: 28px;
  border-radius: 14px;
  object-fit: cover;
  margin-right: 8px;
`;

export const LiveTalkUserInfo = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LiveTalkUsername = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #333;
`;

export const LiveTalkTime = styled.span`
  font-size: 11px;
  color: #999;
`;

export const LiveTalkContent = styled.div`
  font-size: 14px;
  color: #555;
  line-height: 1.4;
  white-space: pre-wrap;
  text-align: left;
`;

export const LiveTalkEmpty = styled.div`
  padding: 40px 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`;
